import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import { RoutingPaths } from 'app/routes/routes.ts'

import { Button } from 'shared/ui/button'

import s from './styles.module.scss'

export const FavoritesEmpty = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const goHome = () => {
    navigate(RoutingPaths.path())
  }

  return (
    <div className={s.container}>
      <div className={s.info}>
        <p className={clsx('bold-20', s.title)}>
          {t('favorites_block.empty.title')}{' '}
        </p>
        <p className={clsx('regular-14', s.text)}>
          {t('favorites_block.empty.subtitle')}
        </p>
      </div>

      <Button
        className={s.btn}
        onClick={goHome}
      >
        {t('favorites_block.empty.find')}
      </Button>
    </div>
  )
}
